import React from 'react';
import classnames from'classnames';
import styles from './styles.module.scss';

export const InteractionsMenuItem = ({
                                       label,
                                       icon,
                                       onClick,
                                       customClassnames,
                                       ...itemProps
                                     }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      className={classnames(styles.interactionOption, customClassnames)}
      {...itemProps}
      onClick={handleClick}
    >
      {icon && <img src={icon} alt={label}/>}
      <div>{label}</div>
    </div>
  );
};

export const InteractionsPreviewItem = ({
                                          label,
                                          icon,
                                          onClick,
                                          customClassnames,
                                          ...itemProps
                                        }) => ({openModal, closeModal}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }

    openModal();
  };

  return (
    <InteractionsMenuItem
      label={label}
      icon={icon}
      onClick={handleClick}
      customClassnames={customClassnames}
      {...itemProps}
    />
  )
};
